'use client'
import { FunctionComponent, useState } from 'react'
import Loader from '../Loader/Loader'
import FilterProductFormMenuOrderBy from '../FilterProductForm/FilterProductFormMenuOrderBy'
import {
  SORT_BY_PERTINENCE,
  SORT_BY_PRICE_ASC,
  SORT_BY_PRICE_DESC,
  SortByChoice,
} from '../FilterProductForm/FilterProductFormMobile/OrderProducts'
import Layout from '../Layout/Layout'
import ListSelection from '../ListSelection/ListSelection'
import { CelineProductsBySpecificCategories } from '../../../domain/celine'
import BreadCrumb from '../BreadCrumb/Breadcrumb'
import { CustomCmsCategory } from '../../../domain/cmsCategory'
import { SelectionItem } from '../../../domain/selectionItem'
import { useIsMobile } from '../../utils/screen.utils'
import { useTranslation } from '../../context/ConfigContext'

type LandingCelineProps = {
  urlPath: string
  productsBySpecificCategories: CelineProductsBySpecificCategories[]
  cmsCategory: CustomCmsCategory
}

const LandingCeline: FunctionComponent<LandingCelineProps> = ({
  productsBySpecificCategories,
  cmsCategory,
}) => {
  const [sortBy, setSortBy] = useState<SortByChoice>(SORT_BY_PERTINENCE)
  const t = useTranslation()

  const listProductsLength = productsBySpecificCategories
    .map((cat) => cat.items.length)
    .reduce((acc, value) => acc + value)

  const breadcrumb = cmsCategory.breadcrumbs.map((item) => ({
    id: item.categoryId,
    name: item.categoryName,
    url: item.categoryUrlPath,
  }))

  const sort = (items: SelectionItem[]) => {
    if (sortBy === SORT_BY_PRICE_ASC) {
      return items.sort((a, b) =>
        (a.priceRange?.minimum_price.regular_price.value || 0) <
        (b.priceRange?.minimum_price.regular_price.value || 0)
          ? -1
          : 1,
      )
    }

    if (sortBy === SORT_BY_PRICE_DESC) {
      return items.sort((a, b) =>
        (a.priceRange?.minimum_price.regular_price.value || 0) >
        (b.priceRange?.minimum_price.regular_price.value || 0)
          ? -1
          : 1,
      )
    }

    return items
  }

  const isMobile = useIsMobile()

  return (
    <>
      <div className='filter-product-form'>
        <div className='filter-product-form-desktop'>
          <div className='filter-product-form-menu'>
            <div className='filter-product-form-menu-right'>
              {!isMobile && (
                <p className='filter-product-form-nbarticle'>
                  {listProductsLength ? `${listProductsLength} ` : ''}
                  {t('Items', {}, true)}{' '}
                </p>
              )}
              {/* TODO */}
              <FilterProductFormMenuOrderBy sortBy={sortBy} onChange={setSortBy} />
            </div>
          </div>
        </div>
      </div>

      <Layout container='padding'>
        <>
          <BreadCrumb breadcrumbs={breadcrumb} name={cmsCategory.name ?? ''} />

          {!productsBySpecificCategories.length ? (
            <Loader />
          ) : (
            productsBySpecificCategories.map(({ label, labelFr, items }, i) => {
              if (label === 'Others') {
                return null
              }
              return (
                <div
                  key={`${label}${sortBy}`}
                  className={`celine-list-products-slider celine-list-products-by-categories${i}`}>
                  <ListSelection
                    items={sort([...items])}
                    listId={labelFr || label}
                    listName={"Liste d'articles collection Céline"}
                    name={<h4 className='title-h4 list-selection-title'>{label}</h4>}
                    parentClassName={`celine-list-products-by-categories${i}`}
                    disableSwiperOfImages
                  />
                </div>
              )
            })
          )}
        </>
      </Layout>
    </>
  )
}

export default LandingCeline
